import React, { Fragment } from 'react';
const planillas = [{
  emoji: '📄',
  title: 'Registro de Avance por Sesión',
  desc: 'Hoja de registro clínico breve para documentar cada sesión.'
}, {
  emoji: '📄',
  title: 'Ficha de Admisión Clínica',
  desc: 'Datos del paciente, antecedentes y motivo de consulta.'
}, {
  emoji: '📄',
  title: 'Ficha de Seguimiento Terapéutico',
  desc: 'Evolución por área a lo largo del proceso terapéutico.'
}, {
  emoji: '📄',
  title: 'Planificador Clínico Semanal',
  desc: 'Organización de objetivos y propuestas por semana.'
}, {
  emoji: '📄',
  title: 'Banco de Objetivos Redactados',
  desc: 'Objetivos listos para copiar y adaptar por etapa.'
}, {
  emoji: '📄',
  title: 'Informe de Acompañamiento para Familias',
  desc: 'Devolución clara y profesional para entregar a los padres.'
}];
const steps = [{
  num: '1',
  label: 'MegaPack Base',
  active: false
}, {
  num: '2',
  label: 'Gestión Completa',
  active: true
}, {
  num: '3',
  label: 'Consultorio Profesional',
  active: false
}];
export function Bonuses() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    background: 'linear-gradient(180deg, #ffffff 0%, rgb(224,247,252) 20%, rgb(224,247,252) 80%, #ffffff 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-40">
      <div className="mx-auto max-w-4xl" data-id="element-41">
        {/* Stepper — circles are evenly spaced; labels wrap to 2 lines so they never overflow */}
        <div className="mx-auto mb-10 max-w-xs sm:max-w-md px-8 flex items-center justify-between" data-id="element-42">
          {steps.map((step, i) => <Fragment key={step.num} data-id="element-43">
              <div className="relative flex-shrink-0" data-id="element-44">
                <div className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-black shadow-sm" style={{
              backgroundColor: step.active ? 'rgb(0,180,216)' : 'rgb(200,235,245)',
              color: step.active ? '#ffffff' : 'rgb(0,150,190)',
              border: step.active ? '2px solid rgb(0,180,216)' : '2px solid rgb(180,225,240)',
              transform: step.active ? 'scale(1.15)' : 'scale(1)'
            }} data-id="element-45">
                  {step.num}
                </div>
                {/* Label constrained to a fixed narrow width so it wraps instead of overflowing */}
                <span className="absolute top-full left-1/2 -translate-x-1/2 mt-1 text-[10px] font-bold text-center leading-tight w-[72px]" style={{
              color: step.active ? 'rgb(0,180,216)' : 'rgb(160,200,215)'
            }} data-id="element-46">
                  {step.label}
                </span>
              </div>
              {i < steps.length - 1 && <div className="flex-1 h-0.5 mx-2" style={{
            backgroundColor: i === 0 ? 'rgb(0,180,216)' : 'rgb(200,235,245)'
          }} data-id="element-47" />}
            </Fragment>)}
        </div>

        {/* Offer badge */}
        <div className="flex justify-center mb-4" data-id="element-48">
          <div className="flex flex-col items-center gap-1 text-white rounded-full px-10 py-3 shadow-md" style={{
          background: 'linear-gradient(135deg, rgb(0,150,200) 0%, rgb(0,180,216) 100%)'
        }} data-id="element-49">
            <span className="text-xs font-black uppercase tracking-[3px] text-white" data-id="element-50">
              ⭐ Oferta 2
            </span>
            <span className="text-base font-black text-white leading-tight" data-id="element-51">
              MegaPack Gestión Completa
            </span>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-2xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-52">
          Todo lo anterior, más:
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-6" data-id="element-53">
          6 Planillas clínicas listas para organizar tu consultorio desde el
          primer día
        </p>

        {/* Oferta 1 incluida */}
        <div className="flex items-center gap-3 bg-white border border-cyan-brand/20 rounded-xl px-5 py-4 mb-6 shadow-sm" data-id="element-54">
          <span className="text-xl" data-id="element-55">✅</span>
          <div data-id="element-56">
            <span className="block text-sm font-black text-gray-900" data-id="element-57">
              MegaPack Base completo incluido
            </span>
            <span className="text-xs text-gray-500" data-id="element-58">
              6 Tomos · 144 actividades · 6 Bonos · 0 a 36 meses
            </span>
          </div>
        </div>

        {/* Header planillas */}
        <div className="rounded-t-xl px-5 py-4" style={{
        background: 'linear-gradient(135deg, rgb(0,150,200) 0%, rgb(0,180,216) 100%)',
        border: '2px solid rgb(0,180,216)',
        borderBottom: 'none'
      }} data-id="element-59">
          <p className="text-[10px] font-bold uppercase tracking-widest text-white/70 m-0 mb-1" data-id="element-60">
            Exclusivo Oferta 2
          </p>
          <h3 className="text-base font-black text-white m-0" data-id="element-61">
            📋 6 Planillas Clínicas Editables
          </h3>
          <p className="text-xs text-white/80 m-0 mt-1" data-id="element-62">
            Diseñadas para usar directo en consultorio — sin adaptar, sin
            improvisar
          </p>
        </div>

        {/* Cards grilla 2x3 */}
        <div className="rounded-b-xl overflow-hidden shadow-lg" style={{
        border: '2px solid rgb(0,180,216)',
        borderTop: 'none'
      }} data-id="element-63">
          <div className="bg-white p-4 grid grid-cols-2 gap-3" data-id="element-64">
            {planillas.map((item, i) => <div key={i} className="flex flex-col gap-2 rounded-xl p-4 border border-cyan-brand/10" style={{
            backgroundColor: 'rgb(245,252,255)'
          }} data-id="element-65">
                <div className="flex items-center justify-between" data-id="element-66">
                  <span className="text-2xl" data-id="element-67">{item.emoji}</span>
                  <span className="text-[10px] font-black text-cyan-brand border border-cyan-brand/30 bg-white rounded-full px-2 py-0.5" data-id="element-68">
                    INCLUIDA
                  </span>
                </div>
                <span className="text-sm font-black text-gray-900 leading-tight" data-id="element-69">
                  {item.title}
                </span>
                <span className="text-xs text-gray-500 leading-snug" data-id="element-70">
                  {item.desc}
                </span>
              </div>)}
          </div>

          {/* Footer */}
          <div className="px-5 py-3 flex items-center justify-between" style={{
          backgroundColor: 'rgb(240,249,255)'
        }} data-id="element-71">
            <p className="text-xs text-gray-500 m-0" data-id="element-72">
              Editables · Imprimibles · Listas para usar
            </p>
            <span className="text-[10px] font-black text-white bg-cyan-brand rounded-full px-3 py-1" data-id="element-73">
              6 PLANILLAS
            </span>
          </div>
        </div>
      </div>
    </section>;
}